import en from './en';
import ru from './ru';

import type { TNotificationLocale } from '@components/components/CdsNotification/composable';
import type { NTable } from '@components/components/CdsTable/interface';
import type { NUploader } from '@components/components/CdsUploader/interface';
import type { TDateLocale } from '@components/utils';

export interface ILocale {
  notification: TNotificationLocale;
  table: NTable.ILocale;
  date: TDateLocale;
  time: {
    now: string;
  };
  container: {
    prev?: string;
    next?: string;
  };
  slideView: {
    prev?: string;
    next?: string;
  };
  uploader: NUploader.ILocale;
  dropdown: {
    noData: string;
    selectAll: string;
  };
}

export const availableLocale = ['ru', 'en'] as const;
export type TAvailableLocale = typeof availableLocale[number];

export default { ru, en };
